import React, { Component } from 'react';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import PasswordForgetForm from './PasswordForgetForm';
import bg from './bg-02.jpg';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "400px",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    alignSelf: "center",
    marginTop: theme.spacing.unit*4,
  }
});

const PasswordForgetPage = ({ classes }) =>
  <div className={classes.root}>
    <Card className={classes.card}>
      <Typography className={classes.title} variant="display1">Reset Password</Typography>
      <PasswordForgetForm />
    </Card>
  </div>

export default withStyles(styles)(PasswordForgetPage);



// WEBPACK FOOTER //
// ./src/components/auth/PasswordForget.jsx